import React from 'react';
import { Layout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';

export type LayoutFooterProps = LayoutProps;

const ProLayoutFooter: React.FC<LayoutFooterProps> = React.forwardRef<
  any,
  LayoutFooterProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return (
    <Layout.Footer ref={ref} {...resProps}>
      {children}
    </Layout.Footer>
  );
});

export default ProLayoutFooter;
